export const quizDuration = 60000;

export const defaultQuestions = [
    {
        "category": "Entertainment: Film",
        "type": "multiple",
        "difficulty": "easy",
        "question": "Which of the following movies was not based on a novel by Stephen King? ",
        "correct_answer": "The Thing",
        "incorrect_answers": [
            "Carrie",
            "Misery",
            "The Green Mile"
        ]
    },
    {
        "category": "Entertainment: Film",
        "type": "multiple",
        "difficulty": "easy",
        "question": "When was the movie &#039;Con Air&#039; released?",
        "correct_answer": "1997",
        "incorrect_answers": [
            "1985",
            "1999",
            "1990"
        ]
    },
    {
        "category": "Entertainment: Film",
        "type": "multiple",
        "difficulty": "easy",
        "question": "Which actress danced the twist with John Travolta in &#039;Pulp Fiction&#039;?",
        "correct_answer": "Uma Thurman",
        "incorrect_answers": [
            "Kathy Griffin",
            "Pam Grier",
            "Bridget Fonda"
        ]
    },
    {
        "category": "Entertainment: Film",
        "type": "multiple",
        "difficulty": "easy",
        "question": "Who starred in the film 1973 movie &quot;Enter The Dragon&quot;?",
        "correct_answer": "Bruce Lee",
        "incorrect_answers": [
            "Jackie Chan",
            "Jet Li",
            " Yun-Fat Chow"
        ]
    },
    {
        "category": "Entertainment: Film",
        "type": "multiple",
        "difficulty": "easy",
        "question": "This movie contains the quote, &quot;Houston, we have a problem.&quot;",
        "correct_answer": "Apollo 13",
        "incorrect_answers": [
            "The Right Stuff",
            "Capricorn One",
            "Marooned"
        ]
    },
    {
        "category": "Entertainment: Film",
        "type": "multiple",
        "difficulty": "easy",
        "question": "This movie contains the quote, &quot;I feel the need ... the need for speed!&quot;",
        "correct_answer": "Top Gun",
        "incorrect_answers": [
            "Days of Thunder",
            "The Color of Money",
            "Cocktail"
        ]
    },
    {
        "category": "Entertainment: Film",
        "type": "multiple",
        "difficulty": "easy",
        "question": "When does &quot;Rogue One: A Star Wars Story&quot; take place chronologically in the series?",
        "correct_answer": "Between Episode 3 and 4",
        "incorrect_answers": [
            "After Episode 6",
            "Before Episode 1",
            "Between Episode 4 and 5"
        ]
    },
    {
        "category": "Entertainment: Film",
        "type": "multiple",
        "difficulty": "easy",
        "question": "Who plays the character of Po in the Kung Fu Panda movies?",
        "correct_answer": "Jack Black",
        "incorrect_answers": [
            "Mirana Jonnes",
            "McConahey Ramses",
            "Jim Petersson"
        ]
    },
    {
        "category": "Entertainment: Film",
        "type": "multiple",
        "difficulty": "easy",
        "question": "What is the name of the island that &quot;Jurassic Park&quot; is built on?",
        "correct_answer": "Isla Nublar",
        "incorrect_answers": [
            "Isla Sorna",
            "Isla Muerta",
            "Isla Pena"
        ]
    },
    {
        "category": "Entertainment: Film",
        "type": "multiple",
        "difficulty": "easy",
        "question": "In &quot;ALF&quot;, what was ALF&#039;s real name?",
        "correct_answer": "Gordon Shumway",
        "incorrect_answers": [
            "Gordon Milipp",
            "Gordon Foster",
            "Gordon von Gam"
        ]
    }
]